import axios from 'axios';

const OrderService = {
  async save(orderData) {
    return axios.post('/order/api/index', orderData);
  }
};

export default OrderService;